import React from "react";
import Modal from "react-bootstrap/Modal";
import RemoveAttachmentIcon from "../../images/remove_attachment_icon.svg";
import AppStyles from "../../config/styles";
import {AddChildCloseIcon, RemoveAttachmentIconDiv} from "../atoms/ConnectStories";
import { Div } from "../atoms/Div";

const styles = {
  modal: {
    justifyContent: "flex-end",
    margin: 0,
  },
  viewstyle: {
    backgroundColor: "white",
    borderRadius: "12px",
    textAlign:"center",
    paddingBottom:"3%",
  },
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },

  titlestyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "25px",
    color: "black",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    width: "90%",
    margin: "0 auto",
    padding: "3%"
  },
  desstyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "18px",
    color: "black",
    marginTop: "2rem",
    marginLeft: "20px",
    marginRight: "15px",
    alignSelf: "center",
  },
  galleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    paddingTop: "15px",
    paddingBottom: "15px",
    textAlign: "center",
    width: "55%",
    margin: "15px auto 0",
    boxShadow: "rgb(199, 83, 0) 0px 3px 0px",
    cursor:"pointer",
  },
  mobileGalleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    paddingTop: "15px",
    paddingBottom: "15px",
    textAlign: "center",
    width: "70%",
    margin:"0 auto",
    cursor:"pointer",
  },
  gallerytextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    cursor:"pointer",
  },
  camerapressstyle: {
    padding: 10,
    textAlign: "center",
    cursor:"pointer",
  },
  cameratextstyle: {
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    color: AppStyles.colors.COLOR_GREY3,
    textDecorationLine: "underline",
    alignSelf: "center",
    marginTop: "25px",
    marginBottom: "30px"
  },
};

function RemoveAttachmentModal(props) {
    const isMobile = window.innerWidth <= 767;
  return (
    <Modal
      show={props?.isVisible}
      onBackButtonPress={props?.onClose}
      onBackdropPress={props?.onClose}
      style={styles.modal}
      dialogClassName="vertical-custom-modal"
    >
         <AddChildCloseIcon  onClick={props?.onClose}>X</AddChildCloseIcon>
      <div style={styles.viewstyle}>
        <RemoveAttachmentIconDiv>
            <img src={RemoveAttachmentIcon} alt=""/>
        </RemoveAttachmentIconDiv>
        <p style={styles.titlestyle}>{props?.title}</p>
          <p style={styles.desstyle}>{props?.textValue}</p>
          <Div flexdiv draftSaveButton onClick={props?.onProceedClick}>
            <div style={isMobile ? styles.mobileGalleryviewstyle : styles.galleryviewstyle}>
              <span style={styles.gallerytextstyle}>{props?.onProceedText}</span>
            </div>
          </Div>
          <Div style={styles.camerapressstyle} onClick={props?.onCancelClick}>
            <span style={styles.cameratextstyle}>{props?.onCancelText}</span>
          </Div>
        </div>
    </Modal>
  );
}

export default RemoveAttachmentModal;
